import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment";


export interface IRagUIConfig {
  backendUri: string
}

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  readonly _environment: {
    uid: string
    backendUri: string
  }

  constructor() {
    this._environment = environment
  }

  getConfigUid(): string {
    return this._environment.uid
  }

  getConfig(): IRagUIConfig {
    return {
      backendUri: this._environment.backendUri
    }
  }
}
